// Radio — native radio with a custom green dot. Group by sharing `name`.

import { forwardRef, type InputHTMLAttributes } from 'react';

export interface RadioProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
}

const Radio = forwardRef<HTMLInputElement, RadioProps>(function Radio(
  { label, className = '', disabled, ...rest },
  ref,
) {
  const classes = ['app-radio', disabled && 'is-disabled', className].filter(Boolean).join(' ');

  return (
    <label className={classes}>
      <input ref={ref} type='radio' className='app-radio__input' disabled={disabled} {...rest} />
      <span className='app-radio__circle' aria-hidden='true' />
      {label && <span className='app-radio__label'>{label}</span>}
    </label>
  );
});

export default Radio;
